import React, { Children, useEffect, useState } from 'react';
import { Modal, Button, Form, Card, Spin, Input, Checkbox, DatePicker, Space, Select, Tooltip, Avatar, message, Row, Col, Typography } from 'antd';
import { MailOutlined, InfoCircleOutlined, PhoneOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import ApiService from '../Components/apiService'; // Import ApiService class
import { BASE_URL, DateFormat, DateTimeFormat } from '../Components/Constant'; // Define the date format
import customParseFormat from 'dayjs/plugin/customParseFormat';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import DynamicSelect from './DynamicSelectForLookup';
import { useSelector } from 'react-redux';
import Cookies from 'js-cookie';
import ChatEditor from '../ChatTextEditor/ChatEditor';


const { Title } = Typography;

dayjs.extend(customParseFormat);

const CreateRecordModal = ({
  visible,
  onClose,
  onFinish,
  loading,
  fieldsData,
  selectedRecord,
  selectedDate,
  setSelectedDate,
  handleFinishFailed,
  form,
  objectName,
  // layout,
  isRelatedCreate,
  isFieldReadOnly,
  logbook,
  isFromRelatedRecord,
  currentRelatedList


}) => {
  const [lookupOptionforparent, setLookupOptionsForParent] = useState([]);
  const [richTextContent, setRichTextContent] = useState('');
  const security = useSelector(state => state.data.items[0]);
  const [currency, setCurrency] = useState('');
  const [recordTypes, setRecordTypes] = useState([]);
  const [selectedRecordTypeId, setSelectedRecordTypeId] = useState(null);
  const [dynamicLayout, setDynamicLayout] = useState([]);
  const [step, setStep] = useState(1); // 1 = RecordType select, 2 = Form
  const [layout, setLayout] = useState([]);
  const defaultCurrency = useSelector(state => state.data.orgItem);
  const loginUserCurrency = Cookies.get('userCurrency');
  const [LoadRecordTypes, setLoadRecordTypes] = useState(false);
  const [loadlayout, setLoadLayout] = useState(false);

  const currUserId = Cookies.get('userId');
  const currUserName = Cookies.get('name');


  const fetchOrgSetupDetails = async () => {

    setCurrency(defaultCurrency?.currency);

  };
  useEffect(() => {
    const defaultsToSet = {};

    fieldsData.forEach((field) => {
      if (field.type !== 'picklist') return;

      const override = recordTypes.find(
        (rt) => rt._id === selectedRecordTypeId
      )?.picklist_overrides?.[field.name];

      const picklistValues = Array.isArray(override?.values) && override?.values?.length > 0
        ? override.values.filter(v => v !== null)
        : field.picklist_values || [];

      const defaultValue = override?.default_value;

      if (
        defaultValue &&
        picklistValues.includes(defaultValue)
      ) {
        defaultsToSet[field.name] = defaultValue;
      }

      if (field.name === 'CurrencyIsoCode' && loginUserCurrency) {
        defaultsToSet[field.name] = loginUserCurrency;
      }
    });

    if (Object.keys(defaultsToSet).length > 0) {
      form.setFieldsValue(defaultsToSet);
    }
  }, [fieldsData, selectedRecordTypeId, recordTypes, loginUserCurrency]);


  const fetchRecordTypes = async () => {
    try {
      setLoadRecordTypes(true);
      const api = new ApiService(`${BASE_URL}/record_types/by_object/${objectName}`);
      const response = await api.makeCall();
      setRecordTypes(response || []);
      if (response?.length === 1) {
        setSelectedRecordTypeId(response[0]._id);
        setDynamicLayout(layout); // default to provided layout
        setStep(2);
      }

    } catch {
      console.log('Failed to fetch record types');
    }
    finally {
      setLoadRecordTypes(false);
    }
    // setLoading(false);

  }

  const fetchLayoutForRecordType = async (recordTypeId) => {
    try {
      // const matchingRecordType = recordTypes.find(recordType => recordType.id === recordTypeId);
      const api = new ApiService(`${BASE_URL}/get_layout_by_record_type/${objectName}/${recordTypeId}`);
      const response = await api.makeCall();
      setDynamicLayout([response] || []);
    } catch {
    }
  };

  // const handleRecordTypeChange = async (recordTypeId) => {
  //   setSelectedRecordTypeId(recordTypeId);
  //   await fetchLayoutForRecordType(recordTypeId);
  // };

  useEffect(() => {
    fetchLayouts();
    fetchRecordTypes();
    fetchOrgSetupDetails();
  }, []);

  useEffect(() => {
    if (selectedRecord) {
      setStep(2);
      fetchLayoutForRecordType(selectedRecord?.RecordType)
      // Populate the form with selected record's data
      const formValues = {};
      fieldsData.forEach(field => {
        if (field?.type === 'date' || field?.type === 'datetime') {
          formValues[field?.name] = selectedRecord[field?.name]
            ? dayjs(selectedRecord[field?.name], field?.type === 'date' ? DateFormat : DateTimeFormat)
            : null;
        } else if (field?.type === 'boolean') {
          formValues[field?.name] = selectedRecord[field?.name] || false;
        } else if (field?.type === 'address') {
          // Assuming address fields are stored as separate properties
          formValues[`${field?.name}_street`] = selectedRecord[`${field?.name}_street`] || '';
          formValues[`${field?.name}_city`] = selectedRecord[`${field?.name}_city`] || '';
          formValues[`${field?.name}_state`] = selectedRecord[`${field?.name}_state`] || '';
          formValues[`${field?.name}_country`] = selectedRecord[`${field?.name}_country`] || '';
          formValues[`${field?.name}_postalcode`] = selectedRecord[`${field?.name}_postalcode`] || '';
        } else if (field?.type === 'richtext') {
          formValues[field?.name] = selectedRecord[field?.name] || '';
        } else {
          formValues[field?.name] = selectedRecord[field?.name] || '';
        }
      });
      form.setFieldsValue(formValues);
    } else {
      if (isRelatedCreate === undefined || isRelatedCreate === null || isRelatedCreate === false) {
        form.resetFields();
        const value = {
          _id: currUserId,
          Name: currUserName,
        }
        form.setFieldsValue({ User: value });
      }
      if (isRelatedCreate) {
        const value = {
          _id: currUserId,
          Name: currUserName,
        }
        form.setFieldsValue({ User: value });
      }
      if (selectedDate) {
        form.setFieldsValue({ Date: dayjs(selectedDate, DateFormat) });
      }

      setRichTextContent(''); // Reset the form if no record is selected (for new record)
    }
  }, [selectedRecord, form, fieldsData]);



  const handleSearch = async (value, fieldId, name, callback) => {
    const allFields = form.getFieldsValue();

    const filteredFields = Object.entries(allFields)
      .filter(([key, fieldValue]) => key !== name)
      .reduce((acc, [key, fieldValue]) => {
        acc[key] = fieldValue;
        return acc;
      }, {});
    if (value) {
      try {
        const apiService = new ApiService(`${BASE_URL}/search_lookup/${fieldId}/${value}`, {
          'Content-Type': 'application/json', // Add any necessary headers, such as content type
        }, 'POST', { child_context: selectedRecord ? selectedRecord : filteredFields });
        const response = await apiService.makeCall();
        // Assuming the response data structure has options as an array
        setLookupOptionsForParent(prevOptions => ({
          ...prevOptions,
          [name]: response // Store the response for the specific field name
        }));
      } catch (error) {
        setLookupOptionsForParent(prevOptions => ({
          ...prevOptions,
          [name]: []
        }));
      } finally {
        callback();
      }
    } else {
      setLookupOptionsForParent(prevOptions => ({
        ...prevOptions,
        [name]: []
      }));
      callback();
    }
  };

  const fetchLayouts = async () => {
    // setLoading(true);
    try {
      const layouts = new ApiService(`${BASE_URL}/get_by_objectName/${objectName}`, {}, 'GET');
      const res = await layouts.makeCall();
      if (res) {
        const activeLayout = res.filter(layout => layout.active);
        setLayout(activeLayout);
        // setDynamicLayout(activeLayout);
      }


    } catch (err) {
      console.error("Error fetching metadata:", err);
    } finally {
      // setLoading(false);
      setLoadLayout(true);
    }
  };

  const renderFormItem = (field) => {

    if (field?.is_auto_number || field?.is_formula || field?.type === 'rollup') {
      return null;
    }

    if (field?.name === 'recordCount' || field?.name === 'CreatedBy' || field?.name === 'LastModifiedBy') {
      return null;
    }

    const isDisable = selectedRecord?._id ? !security?.object_settings?.[objectName]?.field_setting?.[field?.name]?.edit : !security?.object_settings?.[objectName]?.field_setting?.[field?.name]?.create;

    const isRequired = field?.required ? [{ required: true, message: `${field?.label} is required!` }] : [];

    // Check if help text is present for the field
    const renderLabel = (
      <span>
        {field?.label}
        {field?.help_text && field?.help_text.trim() !== "" && (
          <Tooltip title={field?.help_text}>
            <InfoCircleOutlined style={{ marginLeft: 8, color: '#1890ff' }}></InfoCircleOutlined>
          </Tooltip>
        )}
      </span>
    );

    switch (field?.type) {
      case 'string':
        return (
          <Form.Item
            key={field?.name}
            name={field?.name}
            label={renderLabel}  // Use the custom label here
            rules={isRequired}
          >
            <Input placeholder={`Enter ${field?.label}`} disabled={isDisable} />
          </Form.Item>
        );

      case 'integer':
        return (
          <Form.Item
            key={field?.name}
            name={field?.name}
            label={renderLabel}  // Use the custom label here
            rules={isRequired}
          >
            <Input type="number" placeholder={`Enter ${field?.label}`} disabled={isDisable} />
          </Form.Item>
        );

      case 'phone':
        return (
          <Form.Item
            key={field?.name}
            name={field?.name}
            label={renderLabel} // Use the custom label here
            rules={isRequired}

          >
            <Input
              placeholder={`Enter ${field?.label}`}
              addonBefore={
                <PhoneOutlined style={{ cursor: 'pointer' }} />
              }
              disabled={isDisable}
            />
          </Form.Item>
        );

      case 'email':
        return (
          <Form.Item
            key={field?.name}
            name={field?.name}
            label={renderLabel}  // Use the custom label here
            rules={[
              { type: 'email', message: 'The input is not valid E-mail!' },
              ...isRequired
            ]}
          >
            <Input type='email' prefix={<MailOutlined />} placeholder="Enter email" disabled={isDisable} />
          </Form.Item>
        );

      case 'boolean':
        return (
          <Form.Item
            key={field?.name}
            name={field?.name}
            valuePropName="checked"
            initialValue={false}
            label={renderLabel}
          >
            <Checkbox disabled={isDisable}></Checkbox>
          </Form.Item>
        );

      case 'date':
        return (
          <Form.Item
            key={field?.name}
            name={field?.name}
            label={renderLabel}  // Use the custom label here
            rules={isRequired}
          >
            <Space>
              <DatePicker
                placeholder={`Select ${field?.label}`}
                style={{ width: '100%' }}
                format={DateFormat}
                // disabled={isDisable}
                value={form.getFieldValue(field?.name) ? dayjs(form.getFieldValue(field?.name), DateFormat) : null}
                onChange={(date, dateString) => {
                  setSelectedDate(date ? dayjs(dateString, DateFormat) : null);
                  form.setFieldsValue({ [field?.name]: dateString });
                }}
                disabled={logbook || isDisable}
              />
            </Space>
          </Form.Item>
        );

      case 'datetime':
        return (
          <Form.Item
            key={field?.name}
            name={field?.name}
            label={renderLabel}  // Use the custom label here
            rules={isRequired}
          >
            <Space>
              <DatePicker
                showTime
                placeholder={`Select ${field?.label}`}
                style={{ width: '100%' }}
                disabled={isDisable}
                format={DateTimeFormat}
                value={form.getFieldValue(field?.name) ? dayjs(form.getFieldValue(field?.name), DateTimeFormat) : null}
                onChange={(date, dateString) => {
                  setSelectedDate(date ? dayjs(dateString, DateTimeFormat) : null);
                  form.setFieldsValue({ [field?.name]: dateString });
                }}
              />
            </Space>
          </Form.Item>
        );

      case 'url':
        return (
          <Form.Item
            key={field?.name}
            name={field?.name}
            label={renderLabel}  // Use the custom label here
            rules={[
              { type: 'url', message: 'Please enter a valid URL!' },
              ...isRequired
            ]}
          >
            <Input type="url" placeholder={`Enter ${field?.label}`} disabled={isDisable} />
          </Form.Item>
        );

      case 'currency':
        const currencyDecimalPlacesBefore = field?.decimal_places_before;
        const currencyDecimalPlacesAfter = field?.decimal_places_after;
        const regexPattern = new RegExp(`^\\d{1,${currencyDecimalPlacesBefore}}(\\.\\d{0,${currencyDecimalPlacesAfter}})?$`);
        const handleCurrencyInput = (event) => {
          const inputValue = event.target.value;
          if (!regexPattern.test(inputValue)) {
            event.preventDefault();
          }
        };

        return (
          <Form.Item
            key={field?.name}
            name={field?.name}
            label={renderLabel}  // Use the custom label here
            rules={isRequired}
          >
            <Input
              // addonBefore={currency || '$'}
              placeholder={`Enter ${field?.label}`}
              onInput={handleCurrencyInput}
              disabled={isDisable}
              maxLength={currencyDecimalPlacesBefore + currencyDecimalPlacesAfter + 1}
            />
          </Form.Item>
        );

      case 'picklist':
        const override = recordTypes.find(
          (rt) => rt._id === selectedRecordTypeId
        )?.picklist_overrides?.[field.name];

        const finalPicklistValues = Array.isArray(override?.values) && override.values.length > 0
          ? override.values.filter(v => v !== null)
          : field.picklist_values || [];

        const defaultOverrideValue = override?.default_value;


        return (
          <Form.Item
            key={field?.name}
            name={field?.name}
            label={renderLabel}
            rules={[
              ...(field.name === 'CurrencyIsoCode' ? [{ required: true, message: 'Currency is required' }] : []),
              ...isRequired
            ]}
            initialValue={
              field.name === 'CurrencyIsoCode'
                ? loginUserCurrency
                : finalPicklistValues.includes(defaultOverrideValue)
                  ? defaultOverrideValue
                  : undefined
            }



          >
            <Select
              placeholder={`Select ${field?.label}`}
              allowClear
              disabled={isDisable}
            >
              {finalPicklistValues.map((value) => (
                <Select.Option key={value} value={value}>
                  {value}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        );


      case 'multiselect':
        return (
          <Form.Item
            key={field?.name}
            name={field?.name}
            label={renderLabel}  // Use the custom label here
            rules={isRequired}
          >
            <Select
              mode="multiple"
              placeholder={`Select ${field?.label}`}
              allowClear
              disabled={isDisable}
            >
              {field?.picklist_values.map((value) => (
                <Select.Option key={value} value={value}>
                  {value}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        );

      case 'lookup':
        return (
          <Form.Item
            key={field?.name}
            name={field?.name}
            label={renderLabel}
            rules={isRequired}
          >
            <DynamicSelect
              objectName={field?.parent_object_name}
              lookupConfig={field?.lookup_config}
              onSearch={handleSearch}
              value={form.getFieldValue(field?.name)}
              name={field?.name}
              lookupOptionforparent={lookupOptionforparent}
              isFieldReadOnly={isFieldReadOnly}
              fieldId={field?._id}
              onChange={(newValue) => form.setFieldsValue({ [field?.name]: newValue })} // Update form value dynamically
              disabled={isDisable}
            />
          </Form.Item>
        );

      case 'address':
        return (
          <Form.Item
            key={field?.name}
            name={field?.name}
            label={field?.label} // This shows "Address" as the label
          >
            <Card title="Enter Address" bordered={true}>
              <Form.Item
                key={`${field?.name}_street`}
                name={`${field?.name}_street`}
                label="Street"
              >
                <Input placeholder="Enter Street" disabled={isDisable} />
              </Form.Item>
              <Form.Item
                key={`${field?.name}_city`}
                name={`${field?.name}_city`}
                label="City"
              >
                <Input placeholder="Enter City" disabled={isDisable} />
              </Form.Item>
              <Form.Item
                key={`${field?.name}_state`}
                name={`${field?.name}_state`}
                label="State"
              >
                <Input placeholder="Enter State" disabled={isDisable} />
              </Form.Item>
              <Form.Item
                key={`${field?.name}_country`}
                name={`${field?.name}_country`}
                label="Country"
              >
                <Input placeholder="Enter Country" disabled={isDisable} />
              </Form.Item>
              <Form.Item
                key={`${field?.name}_postalcode`}
                name={`${field?.name}_postalcode`}
                label="Postal Code"
              >
                <Input placeholder="Enter Postal Code" disabled={isDisable} />
              </Form.Item>
            </Card>
          </Form.Item>
        );

      case 'decimal':
        const decimalPlacesBefore = field?.decimal_places_before;
        const decimalPlacesAfter = field?.decimal_places_after;
        const decimalPattern = new RegExp(`^\\d{1,${decimalPlacesBefore}}(\\.\\d{0,${decimalPlacesAfter}})?$`);

        return (
          <Form.Item
            key={field?.name}
            name={field?.name}
            label={renderLabel}  // Use the custom label here
            rules={isRequired}
          >
            <Input
              placeholder={`Enter ${field?.label}`}
              maxLength={decimalPlacesBefore + decimalPlacesAfter + 1}
              disabled={isDisable}
              onInput={(e) => {
                const value = e.target.value;
                if (!decimalPattern.test(value)) {
                  e.preventDefault();
                }
              }}
            />
          </Form.Item>
        );

      case 'percentage':
        return (
          <Form.Item
            key={field?.name}
            name={field?.name}
            label={renderLabel}
            rules={isRequired}
          >
            <Input addonAfter="%" type="float" placeholder={`Enter ${field?.label}`} disabled={isDisable} />
          </Form.Item>
        );

      case 'textarea':
        return (
          <Form.Item
            key={field?.name}
            name={field?.name}
            label={renderLabel}  // Use the custom label here
            rules={isRequired}
          >
            <Input.TextArea
              placeholder={`Enter ${field?.label}`}
              disabled={isDisable}
            />
          </Form.Item>
        );

      case 'image':
        return (
          <Form.Item
            key={field?.name}
            name={field?.name}
            label={renderLabel}  // Use the custom label here
            rules={[
              { type: 'url', message: 'Please enter a valid image URL!' },
              ...isRequired
            ]}
          >
            <Input type="url" placeholder={`Enter ${field?.label} URL`} disabled={isDisable} />
          </Form.Item>
        );

      case 'richtext':
        return (
          <Form.Item
            key={field?.name}
            name={field?.name}
            label={renderLabel}
            rules={isRequired}
          >
            <ChatEditor 
                                            onRichTextSaved={ (html)=>{
                                                const content=  String(html || '');
                                                form.setFieldsValue({ [field.name]: content });
                                                // setRichTextValues(prev=>({
                                                //     ...prev,
                                                //     [field.name]:content
                                                // }));
                                            }}
                                            showTools={true}
                                            placeholder={"Write here..."}   
                                            prefill={form.getFieldValue(field.name) || ''}
                                            editMode={true}
                                            isRichTextField={true}
                                        />
          </Form.Item>
        )

      default:
        return null;
    }
  };


  const cancelDrawer = () => {
    form.resetFields();
    onClose();
  }
  return (
    <Modal
      title={
        <div
          style={{
            fontSize: '14px', // max size
            fontWeight: 600,
            padding: '8px 14px', // compact
            borderBottom: '1px solid #e8e8e8',
          }}
          zIndex={1002}
        >
          {selectedRecord?.isClone
            ? `Clone ${selectedRecord?.Name}` 
            : selectedRecord
              ? `Edit ${selectedRecord?.Name}` 
              : logbook
                ? 'Create Log Record'
                : 'Create New Record'}
        </div>
      }
      width="70%"
      onCancel={!loading ? cancelDrawer : null}
      visible={visible}
      className="custom-modal"
      bodyStyle={{
        padding: '8px 12px',
        paddingBottom: 16,
        maxHeight: '65vh',
        overflowY: 'auto',
        fontSize: '13px', // default text
      }}
      headerStyle={{
        padding: '8px 12px',
        background: '#f7f8fa',
        borderBottom: '1px solid #e8e8e8',
        position: 'sticky',
        top: 0,
        zIndex: 1000,
        fontSize: '13px',
      }}
      footer={
        (step === 2 || recordTypes.length === 0) && (
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              padding: '6px 10px',
              background: '#f7f8fa',
              borderTop: '1px solid #e8e8e8',
              position: 'sticky',
              bottom: 0,
              zIndex: 1000,
              fontSize: '13px',
            }}
          >
            <div>
              <Button onClick={onClose} disabled={loading} size="small">
                Cancel
              </Button>
            </div>
            <div>
              {!logbook && (
                <Button
                  style={{ marginRight: 10 }}
                  onClick={() => {
                    form.validateFields().then((values) => {
                      const formData = {
                        ...values,
                        richText: richTextContent,
                        RecordType: selectedRecordTypeId,
                      };
                      onFinish(formData, true, currentRelatedList);
                    });
                  }}
                  disabled={loading}
                  type="primary"
                  size="small"
                >
                  Save & New
                </Button>
              )}
              <Button
                onClick={() => form.submit()}
                disabled={loading}
                type="primary"
                size="small"
              >
                Save
              </Button>
            </div>
          </div>
        )
      }
      footerStyle={{ textAlign: 'right', padding: 0 }}
      zIndex={1002}
    >
      <Spin size="large" spinning={LoadRecordTypes} tip="Loading Record Types...">
        <Spin size="large" spinning={loading} tip="Loading...">
          {recordTypes.length > 1 && step === 1 ? (
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: '35vh',
                fontSize: '13px',
              }}
            >
              <Card
                style={{
                  width: 380,
                  padding: '8px',
                  boxShadow: '0 2px 6px rgba(0, 0, 0, 0.1)',
                  fontSize: '13px',
                }}
              >
                <Title level={5} style={{ fontSize: '14px', marginBottom: 10 }}>
                  Select Record Type
                </Title>
                <Form layout="vertical" style={{ fontSize: '13px' }}>
                  <Form.Item label="Record Type" required>
                    <Select
                      placeholder="Select a record type"
                      value={selectedRecordTypeId}
                      onChange={(value) => setSelectedRecordTypeId(value)}
                      style={{ width: '100%', fontSize: '13px' }}
                    >
                      {recordTypes.map((rt) => (
                        <Select.Option
                          key={rt._id}
                          value={rt._id}
                          style={{ fontSize: '13px' }}
                        >
                          {rt.label}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                  <div
                    style={{
                      marginTop: 12,
                      display: 'flex',
                      justifyContent: 'space-between',
                    }}
                  >
                    <Button onClick={onClose} disabled={loading} size="small">
                      Cancel
                    </Button>
                    <Button
                      type="primary"
                      size="small"
                      onClick={async () => {
                        if (!selectedRecordTypeId)
                          return message.warning('Please select a record type');
                        await fetchLayoutForRecordType(selectedRecordTypeId);
                        setStep(2);
                      }}
                    >
                      Next
                    </Button>
                  </div>
                </Form>
              </Card>
            </div>
          ) : (
            <Card
              style={{
                margin: '4px',
                padding: '6px',
                boxShadow: '0 2px 6px rgba(0, 0, 0, 0.1)',
                fontSize: '13px',
              }}
            >
              <Form
                form={form}
                layout="vertical"
                onFinish={(values) => {
                  const formData = {
                    ...values,
                    richText: richTextContent,
                    RecordType: selectedRecordTypeId,
                  };
                  onFinish(formData);
                }}
                onFinishFailed={handleFinishFailed}
                style={{ fontSize: '13px' }}
              >
                {loadlayout && (
                <Row gutter={16}>
                  {dynamicLayout[0] ? (
                    dynamicLayout[0]?.sections?.map((section, sectionIndex) => {
                      const columnCount = section?.columns?.length || 2;
                      const columnSpan = 24 / columnCount;

                      return (
                        <Col key={sectionIndex} span={24}>
                          <div
                            style={{
                              border: '1px solid #ddd',
                              marginBottom: '20px',
                              padding: '20px',
                              borderRadius: '4px',
                              width: '100%',
                            }}
                          >
                            <Title level={5} style={{ marginTop: '2px' }}>{section.name}</Title>
                            <Row gutter={24} style={{ marginBottom: '0px' }}>
                              {section?.columns?.map((column, columnIndex) => (
                                <Col key={columnIndex} span={columnSpan}>
                                  <div>
                                    {column.items?.map((item, rowIndex) => {
                                      const matchedField = fieldsData?.find(field => field?.name === item?.name);
                                      if (matchedField) {
                                        return (
                                          <Form.Item
                                            key={rowIndex}
                                            style={{ marginBottom: '10px', padding: '0px' }}
                                          >
                                            {renderFormItem(matchedField)}
                                          </Form.Item>
                                        );
                                      }
                                      return null;
                                    })}
                                  </div>
                                </Col>
                              ))}
                            </Row>
                          </div>
                        </Col>
                      );
                    })
                  ) : layout[0]?.sections ? (
                    // Case 2: layout exists but no dynamicLayout
                    layout[0]?.sections.map((section, sectionIndex) => {
                      const columnCount = section?.columns?.length || 2;
                      const columnSpan = 24 / columnCount;

                      return (
                        <Col key={sectionIndex} span={24}>
                          <div
                            style={{
                              border: '1px solid #ddd',
                              marginBottom: '20px',
                              padding: '20px',
                              borderRadius: '4px',
                              width: '100%',
                            }}
                          >
                            <Title level={4} style={{ marginTop: '2px' }}>{section.name}</Title>
                            <Row gutter={24} style={{ marginBottom: '0px' }}>
                              {section?.columns?.map((column, columnIndex) => (
                                <Col key={columnIndex} span={columnSpan}>
                                  <div>
                                    {column.items?.map((item, rowIndex) => {
                                      const matchedField = fieldsData?.find(field => field?.name === item?.name);
                                      if (matchedField) {
                                        return (
                                          <Form.Item
                                            key={rowIndex}
                                            style={{ marginBottom: '10px', padding: '0px' }}
                                          >
                                            {renderFormItem(matchedField)}
                                          </Form.Item>
                                        );
                                      }
                                      return null;
                                    })}
                                  </div>
                                </Col>
                              ))}
                            </Row>
                          </div>
                        </Col>
                      );
                    })
                  ) :
                    (
                      <Col span={24}>
                        <Row gutter={24} style={{ marginBottom: "0px" }}>
                          {fieldsData?.map((field, index) => {

                            <Col key={index} span={12} style={{ marginBottom: -5 }}>
                              <Form.Item>
                                {renderFormItem(field)}
                              </Form.Item>
                            </Col>

                          })}
                        </Row>
                      </Col>
                    )

                  }
                </Row>
                )}
              </Form>
            </Card>
          )}
        </Spin>
      </Spin>
    </Modal>
  );

};

export default CreateRecordModal;
